import * as React from "react";
import Icon from "baseui/icon/icon";
import omitDollarPrefixedKeys from "baseui/icon/omit-dollar-prefixed-keys.js";
import { IconProps } from "baseui/icon";
import { mergeOverride, toObjectOverride } from "baseui/helpers/overrides.js";
import { useStyletron } from "kanopi-components/theme/useStyletron";

function ArrowLeft(props: IconProps, ref) {
  const [, theme] = useStyletron();
  const { overrides = {}, ...restProps } = props;
  const SvgOverride = mergeOverride(
    // Icons from theme really targets the SVG override in the underlying Icon component, but
    // have props typed with IconPropsT. Provided the missing props inline below here.
    {
      component: theme.icons && theme.icons.ArrowLeft ? theme.icons.ArrowLeft : null,
      props: {
        title: "Arrow Left",
        viewBox: "0 0 24 24",
        ...omitDollarPrefixedKeys(restProps),
      },
    },
    overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {}
  );
  return (
    <Icon viewBox="0 0 24 24" ref={ref} overrides={{ Svg: SvgOverride }} {...restProps}>
      <g fill="#000" fillRule="nonzero">
        <path d="M8.707 4.021l-.686-.728-8.752 8.24 8.755 8.174.683-.731-7.975-7.447z" />
        <path d="M.022 11v1h23.956v-1z" />
      </g>
    </Icon>
  );
}

export default React.forwardRef<IconProps, mixed>(ArrowLeft);
